import React, { useEffect, useMemo } from "react";
import './App.css';
import { CssBaseline } from "@mui/material";
import { DarkModeProvider } from "./context/DarkModeContext";
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { HelmetProvider } from 'react-helmet-async';
import RoutesPath from './routes';
import { BrowserRouter } from 'react-router-dom';
import TrialActivationPopupHost from './components/auth/TrialActivationPopupHost';
import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools"; 
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./auth/JwtContext";
import { queryClient } from "./utils/queryClient";
// import { messaging, requestPermission } from "./firebase";
// import { onMessage } from "firebase/messaging";

const languages = [
  {
    code: 'ar',
    name: 'Ar',
    country_code: 'sa',
    dir: 'rtl'
  },
  {
    code: 'en',
    name: 'En',
    country_code: 'gb',
    dir: 'ltr'
  }
]

function App() {
  const { i18n } = useTranslation();
  const currentLanguageCode = Cookies.get('i18next') || 'ar';
  const currentLanguage = useMemo(() => languages.find(l => l.code === currentLanguageCode), [currentLanguageCode]);

  // تحديث الرابط عند تغيير اللغة تلقائيًا
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langFromURL = urlParams.get('lng');

    if (langFromURL && i18n.language !== langFromURL) {
      i18n.changeLanguage(langFromURL);
      Cookies.set('i18next', langFromURL);
    }
  }, [i18n]);

  // استماع لتغيير اللغة وتحديث الرابط
  useEffect(() => {
    const handleLanguageChange = (lng) => {
      const url = new URL(window.location);
      url.searchParams.set('lng', lng);
      window.history.replaceState(null, '', url.toString());
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  // تحديث الاتجاه واللغة في DOM
  useEffect(() => {
    document.dir = currentLanguage.dir || 'rtl';
    document.documentElement.setAttribute('lang', currentLanguage.code || 'ar');
  }, [currentLanguage]);
  // const { t } = useTranslation();

  // useEffect(() => {
  //   document.dir = currentLanguage.dir || 'rtl';
  //   document.getElementsByTagName('html')[0].setAttribute('lang', currentLanguage.code || 'ar');
  // }, [currentLanguage, t]);
  return (
    <>
      <DarkModeProvider>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          {/* <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' /> */}
          <AuthProvider>
            <CssBaseline />
            <HelmetProvider>
              <BrowserRouter>
                <TrialActivationPopupHost />
                <RoutesPath />
              </BrowserRouter>
            </HelmetProvider>
          </AuthProvider>

          <Toaster
            position="top-center"
            gutter={12}
            containerStyle={{ margin: "8px" }}
            toastOptions={{
              success: {
                duration: 6000,
              },
              error: {
                duration: 5000,
              },
              // الإعدادات الافتراضية لباقي الحالات
              style: {
                fontSize: "16px",
                maxWidth: "500px",
                padding: "16px 24px",
                backgroundColor: theme => theme.palette.primary.main,
                color: theme => theme.palette.primary.text,
              },
              // تخصيص حالة الـ loading فقط
              loading: {
                duration: Infinity,
                style: {
                  fontSize: "16px",
                  maxWidth: "500px",
                  padding: "16px 24px",
                  backgroundColor: "#0D47A1", // لون واضح للحفظ
                  color: "#fff",
                  textAlign: "center",
                  marginTop: '100%',
                },
              },
            }}
          />

        </QueryClientProvider>
      </DarkModeProvider>
    </>
  );
}

export default App;
